import { render, staticRenderFns } from "./changShop.vue?vue&type=template&id=51a61783&scoped=true&"
import script from "./changShop.vue?vue&type=script&lang=js&"
export * from "./changShop.vue?vue&type=script&lang=js&"
import style0 from "./changShop.vue?vue&type=style&index=0&id=51a61783&lang=scss&scoped=true&"
import style1 from "./changShop.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "51a61783",
  null
  
)

export default component.exports